import { IonPage, IonRouterOutlet, getPlatforms } from "@ionic/react";
import { useContext, useEffect, useState } from "react";
import { Redirect, Route, Switch } from "react-router";
import AdminContainer from "_+_Portal/_-_Admin";
import isAuthenticated from "../../global/utils/isAuthenticated";
import { PortalProvider } from "../context/Provider";
import GlobalInitializeData from "../GlobalInitializeData";
import PushBootstrap from "../components/Auth/PushBootstrap/PushBootstrap";
import AnalyticsBootstrap from "../components/Genericos/AnalyticsBootstrap/AnalyticsBootstrap";
import PaginaNoEncontrada from "../pages/PaginaNoEncontrada/PaginaNoEncontrada";
import AutocheckinContainer from "../_-_Autocheckin";
import routes from "./listRoutes";
import { GlobalContext } from "global/context/Provider";
import SegundoFactorContainer from "_+_Portal/_-_SegundoFactor";

const RouterPortal = () => {
  const { configState } = useContext(GlobalContext);

  const [routesLeidas, setRoutesLeidas] = useState(false);
  let path = window.location.pathname;
  const widthWindow = window.innerWidth;

  useEffect(() => {
    setRoutesLeidas(true);
  }, []);

  //ESTE USEEFFECT SE FIJA EN EL JSON Y BORRA LAS RUTAS EN FALSE
  useEffect(() => {
    if (configState.config.data !== null) {
      const routeIdsToRemove = [
        { key: "opcVideoTutoriales", id: 24 },
        { key: "opcLaboratorio", ids: [11, 19] },
        { key: "opcRecetaDigital", id: 12 },
        { key: "opcVideoLlamada", id: 16 },
        { key: "opcAtencionSinTurnoPrevio", id: 17 },
        { key: "opcNotificaciones", id: 26 },
        { key: "opcOncologia", id: 27 },
        { key: "opcOrdenDigital", id: 28 },
        { key: "opcBeneficios", id: 29 },
        { key: "opcBuscadorTurnos", id: 30, condition: widthWindow <= 1024 },
        { key: "opcMisRecetas", id: 31 },
        { key: "opcCertificados", id: 32 },
      ];

      routeIdsToRemove.forEach(({ key, id, ids, condition }) => {
        if (configState.config.data[key] === false || condition) {
          const idsToRemove = ids || [id];
          idsToRemove.forEach((routeId) => {
            const index = routes.findIndex((route) => route.id === routeId);
            if (index !== -1) {
              routes.splice(index, 1);
            }
          });
        }
      });
      if (
        ((getPlatforms()[0] === "android" ||
          getPlatforms()[0] === "ios" ||
          getPlatforms()[0] === "iphone") &&
          configState.config.data.opcHome) ||
        widthWindow <= 1024
      ) {
        // Si estoy en la version Mobile no borro la ruta de consulta, estudio y labo
        // ya que se van a poder acceder desdel el menu
      } else {
        const routeIdsToRemove = [9, 10, 11];
        routeIdsToRemove.forEach((routeId) => {
          const index = routes.findIndex((route) => route.id === routeId);
          if (index !== -1) {
            routes.splice(index, 1);
          }
        });
      }
    }
  }, [configState.config.data]);

  return (
    <>
      {routesLeidas && (
        <PortalProvider>
          <PushBootstrap />
          <AnalyticsBootstrap />
          <GlobalInitializeData>
            <IonPage>
              <IonRouterOutlet>
                <Switch>
                  {routes.map((route, key) => {
                    if (
                      route.path.toLocaleLowerCase() ===
                      path.toLocaleLowerCase()
                    ) {
                      document.title = route.title;
                    }
                    return (
                      <Route
                        path={route.path}
                        key={key}
                        render={(props) =>
                          route.needsAuth &&
                          !isAuthenticated() &&
                          path !== "/" ? (
                            <Redirect to="/" />
                          ) : (
                            <route.component {...props} />
                          )
                        }
                        exact
                      />
                    );
                  })}

                  {/* Aca debe ir las rutas de Admin */}
                  <Route path={"/admin"} component={AdminContainer} />
                  {/* <Route
                    path={"/segundoFactor"}
                    component={SegundoFactorContainer}
                  /> */}

                  {/* Aca debe ir las rutas de autocheckin */}
                  <Route
                    path={"/autocheckin"}
                    component={AutocheckinContainer}
                  />

                  {/*  Aca debe ir la ruta 404  */}
                  <Route path="*" component={PaginaNoEncontrada} />
                </Switch>
              </IonRouterOutlet>
            </IonPage>
          </GlobalInitializeData>
        </PortalProvider>
      )}
    </>
  );
};

export default RouterPortal;
